var _path, _path2, _mask, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.002 23.047H13.997V4.952h10.005v18.095Z",
    fill: "#3085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.633 14c0-3.67 1.707-6.94 4.367-9.047a11.339 11.339 0 0 0-7.067-2.46C5.62 2.492.5 7.643.5 14s5.119 11.508 11.433 11.508c2.668 0 5.122-.92 7.067-2.46A11.515 11.515 0 0 1 14.633 14ZM37.5 14c0 6.356-5.118 11.508-11.433 11.508-2.667 0-5.122-.92-7.067-2.46A11.513 11.513 0 0 0 23.368 14c0-3.67-1.708-6.94-4.368-9.047 1.945-1.541 4.4-2.46 7.067-2.46C32.382 2.492 37.5 7.643 37.5 14Z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.998 4.969a11.517 11.517 0 0 1 4.343 9.03c0 3.662-1.698 6.924-4.343 9.032A11.517 11.517 0 0 1 14.655 14c0-3.662 1.698-6.924 4.343-9.031Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.998 4.969a11.517 11.517 0 0 1 4.343 9.03c0 3.662-1.698 6.924-4.343 9.032A11.517 11.517 0 0 1 14.655 14c0-3.662 1.698-6.924 4.343-9.031Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.998 4.969 1.246-1.565-1.246-.992-1.246.992 1.246 1.565Zm0 18.062-1.246 1.564 1.246.993 1.246-.993-1.246-1.564ZM17.752 6.533A9.518 9.518 0 0 1 21.34 14h4c0-4.293-1.993-8.123-5.097-10.596l-2.492 3.129ZM21.34 14a9.518 9.518 0 0 1-3.59 7.466l2.493 3.129A13.517 13.517 0 0 0 25.341 14h-4Zm-1.097 7.466A9.517 9.517 0 0 1 16.655 14h-4c0 4.293 1.993 8.122 5.097 10.595l2.492-3.129ZM16.655 14a9.518 9.518 0 0 1 3.589-7.467l-2.492-3.129A13.518 13.518 0 0 0 12.655 14h4Z",
    fill: "#3085FF",
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.ad12074e67030107cdd7b54b0dadc9ce.svg";
export { ForwardRef as ReactComponent };